import { CalendarCheckIcon } from 'lucide-react'

import { InquiryDateTrendCard } from '@/pages/client-portal/ui/cards/inquiry-date-trend-card/inquiry-date-trend-card'
import { ProcessingTimeCard } from '@/pages/client-portal/ui/cards/processing-time-card/processing-time-card'
import { ProcessingTimeTrendCard } from '@/pages/client-portal/ui/cards/processing-time-trend-card/processing-time-trend-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { useClientPortalInternalSampleStore } from '@/lib/stores/client-portal-internal-sample-store'
import { cn } from '@/lib/utils'

export const ProcessingTime = () => {
  const { currentCase } = useClientPortalInternalSampleStore()

  // Data
  const applicationFilingDate = currentCase?.applicationFiledDate
  const { inquiryIcon, inquiryText, estimatedTime, estimatedTimeUnit } = currentCase?.processingTime ?? {}
  const processingTimeTrendData = currentCase?.processingTimeTrend
  const inquiryDateTrendData = currentCase?.inquiryDateTrend

  // Boolean values for branching UI
  const {
    processingTime: showsProcessingTime,
    processingTimeTrend: showsProcessingTimeTrend,
    inquiryDateTrend: showsInquiryDateTrend,
  } = currentCase?.portalOptions ?? {}

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<CalendarCheckIcon size={24} />} title="Processing Time" />

      <div
        className={cn('flex flex-col gap-y-5 lg:grid', 'mt-5', {
          'lg:grid-cols-[400px_auto] lg:grid-rows-2 lg:gap-5':
            showsProcessingTime && showsProcessingTimeTrend && showsInquiryDateTrend,
          'lg:grid-cols-[400px_auto] lg:grid-rows-1 lg:gap-5':
            showsProcessingTime && (showsProcessingTimeTrend || showsInquiryDateTrend),
          'lg:grid-cols-2 lg:grid-rows-1 lg:gap-5':
            !showsProcessingTime && showsProcessingTimeTrend && showsInquiryDateTrend,
        })}
      >
        {showsProcessingTime && (
          <div className={cn('lg:max-w-[400px]')}>
            <ProcessingTimeCard
              inquiryIcon={inquiryIcon}
              inquiryText={inquiryText}
              estimatedTime={estimatedTime}
              estimatedTimeUnit={estimatedTimeUnit}
            />
          </div>
        )}
        {showsProcessingTimeTrend && (
          <div
            className={cn(
              'min-w-0' // prevent grid content from overflowing grid item
            )}
          >
            <ProcessingTimeTrendCard processingTimeTrendData={processingTimeTrendData} />
          </div>
        )}
        {showsInquiryDateTrend && (
          <div
            className={cn('min-w-0', {
              'lg:col-span-2': showsProcessingTime && showsProcessingTimeTrend && showsInquiryDateTrend,
            })}
          >
            <InquiryDateTrendCard
              applicationFilingDate={applicationFilingDate}
              inquiryDateTrendData={inquiryDateTrendData}
            />
          </div>
        )}
      </div>
    </div>
  )
}
